import {
  TableCell,
  TableHead,
  TableRow,
}                from '@mui/material';
import { columnsType } from 'utils/type-utils';
import { FilterButton, UrlFilterButton } from 'components/table/FilterButton';
import { SortingColumnTitle, UrlSortingColumnTitle } from 'components/table/SortingColumnTitle';
import { FilterProps } from './LargeTable';
import { useRenderContext } from 'hooks/render';

type TableHeaderProps = {
  columns: any[]
  filterProps?: FilterProps
}

const TableHeader = ({columns, filterProps}: TableHeaderProps) => {
  if (!filterProps) {
    return (
      <TableHead>
        <TableRow>
          {columns.map((column, index) => (
            <TableCell key={index} {...column.cellProps} >
              {column.headerName}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>)
  }

  const {context} = useRenderContext()

  return (<TableHead>
    <TableRow>
      {columns.map((column, index) => (
        <TableCell key={index} {...column.cellProps} >
          {context === 'detail'
          ? <SortingColumnTitle column_key={column.key} column_name={column.headerName} filterProps={filterProps}/>
          : <UrlSortingColumnTitle column_key={column.key} column_name={column.headerName} filterProps={filterProps}/>}
          {context === 'detail'
          ? <FilterButton column={column.key} type={column.type} filterProps={filterProps}/>
          : <UrlFilterButton column={column.key} type={column.type}/>}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>)
}

TableHeader.propTypes = {
  columns: columnsType
};

export default TableHeader;

